import { render, staticRenderFns } from "./HomeMeasuresDialog.vue?vue&type=template&id=5264f2b2"
import script from "./HomeMeasuresDialog.vue?vue&type=script&lang=js"
export * from "./HomeMeasuresDialog.vue?vue&type=script&lang=js"
import style0 from "./HomeMeasuresDialog.vue?vue&type=style&index=0&id=5264f2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports